import type {FC} from 'react';
import clsx from 'clsx';

import {CallToAction} from 'components/call-to-action';
import type {CallToActionLineSchema} from 'components/call-to-action-line/schema';

interface Props {
	value: CallToActionLineSchema;
	isDraft: boolean;
}

export const CallToActionLine: FC<Props> = ({value, isDraft}) => {
	return (
		<div className={clsx(['flex', 'gap-x-6', 'gap-y-3', 'flex-wrap', 'my-4', 'w-full'])}>
			{value.callToActions?.map((cta) => (
				<CallToAction key={cta._key} callToAction={cta} isDraft={isDraft} />
			))}
		</div>
	);
};
